var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportForecastComponent',{attrs:{"urls":_vm.urls,"mandatory-filter":_vm.mandatoryFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }